import { CommonModule, NgClass } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MenuRouteMap } from '../shared/variables/menu-route-map';
import { MenuItem } from '../shared/variables/MenuItem';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [RouterLink, NgClass, CommonModule],
})
export class HeaderComponent implements OnInit {
  headerProjectName = environment.headerProjectName;
  environment = environment.environment;
  projectName = environment.projectName;

  activeDropdown: string | null = null;

  userRole = '';
  // Dashboard
  isDashboardActive = true;
  isDashboardNavItemActive = false;
  // activatedRoute: ActivatedRoute;
  // Device Utility
  isDeviceUtilityActive = false;
  isGovernmentServerNavItemActive = false;
  isFOTANavItemActive = false;
  isOTANavItemActive = false;
  isDeviceModelNavItemActive = false;
  isCustomerMasterNavItemActive = false;
  isProductionDevicesNavItemActive = false;
  isDispatchedDevicesNavItemActive = false;
  isDispatchDeviceNavItemActive = false;
  isSamparkEolNavItemActive = false;

  isReportsActive = false;
  isSensoriseSimDataNavItemActive = false;

  // Users
  isUserTabActive = false;
  isUserManagementActive = false;
  isUserRoleActive = false;
  isRoleGroup = false;
  UserView = false;
  UserManagementView = false;

  // Profile
  ProfileView = false;
  isProfileActive = false;
  isMenuOpen = false;
  activeSubMenu = '';

  userPermissions = [];
  userName = '';
  userType = '';
  rawMenu: MenuItem[] = [];
  menuTree: MenuItem[] = [];

  // constructor(public router: Router) { }
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkToken();
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    this.userName = sessionStorage.getItem('userName') || '';
    this.userType = sessionStorage.getItem('roleType') || '';
    this.userRole = sessionStorage.getItem('userRole') || '';
    this.rawMenu = this.userPermissions;
    this.buildMenuTree();
    this.highlightActiveNavMenuNavItem();
  }

  checkToken() {
    if (!sessionStorage.getItem('token')) {
      this.router.navigate(['/login']);
    }
  }

  buildMenuTree() {
    const menuMap = new Map<number, MenuItem>();
    const roots: MenuItem[] = [];

    // Filter only those with view === true
    let visibleMenus = this.rawMenu.filter(
      (item) =>
        item.view === true &&
        item.pageName !== 'Firmware Master' &&
        (item.pageName !== 'Sampark EOL' || this.projectName === 'Sampark')
    );
    // Initialize menuMap and clear children
    visibleMenus.forEach((item) => {
      item.children = [];
      menuMap.set(item.id, item);
    });

    // Build the tree
    visibleMenus.forEach((item) => {
      if (item.parentMenuId === null) {
        roots.push(item);
      } else {
        const parent = menuMap.get(item.parentMenuId);
        if (parent) {
          parent.children!.push(item);
        }
      }
    });

    // Sort by sequenceId at each level
    const sortMenus = (menus: MenuItem[]) => {
      menus.sort((a, b) => a.sequenceId - b.sequenceId);
      menus.forEach((menu) => {
        if (menu.children) {
          sortMenus(menu.children);
        }
      });
    };

    sortMenus(roots);
    this.menuTree = roots;
  }

  highlightActiveNavMenuNavItem() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Check if the current route is a child route of `Device Utility`
        this.isDashboardActive = this.checkIfActive([
          'device-dashboard-page',
          'device-details',
        ]);
        this.isDashboardNavItemActive = this.checkIfActive([
          'device-dashboard-page',
          'device-details',
        ]);
        this.isDeviceUtilityActive = this.checkIfActive([
          'govt-servers',
          'govt-servers-add',
          'fota-batch',
          'device-fota',
          'manual-fota',
          'ota-batch-page',
          'ota-batch-create',
          'ota-batch-view',
          'ota-master',
          'manual-ota',
          'model',
          'model-firmware',
          'customer-master',
          'production-device-page',
          'production-device-add-page',
          'production-device',
          'sampark-eol-page',
          'sampark-eol-device-add-page',
          'dispatch-device-page',
          'dispatch-device-add-page',
        ]);
        this.isGovernmentServerNavItemActive = this.checkIfActive([
          'govt-servers',
          'govt-servers-add',
        ]);
        this.isOTANavItemActive = this.checkIfActive([
          'ota-batch-page',
          'ota-batch-create',
          'ota-batch-view',
          'ota-master',
          'manual-ota',
        ]);
        this.isFOTANavItemActive = this.checkIfActive([
          'fota-batch',
          'device-fota',
          'manual-fota',
        ]);
        this.isDeviceModelNavItemActive = this.checkIfActive([
          'model',
          'model-firmware',
        ]);
        this.isCustomerMasterNavItemActive = this.checkIfActive([
          'customer-master',
        ]);
        this.isProductionDevicesNavItemActive = this.checkIfActive([
          'production-device-page',
          'production-device-add-page',
          'production-device',
        ]);
        this.isDispatchDeviceNavItemActive = this.checkIfActive([
          'dispatch-device-page',
          'dispatch-device-add-page',
        ]);
        this.isSamparkEolNavItemActive = this.checkIfActive([
          'sampark-eol-page',
          'sampark-eol-device-add-page',
        ]);
        this.isReportsActive = this.checkIfActive([
          'sensorise-sim-data-details',
          'sensorise-sim-manual-upload',
        ]);
        this.isSensoriseSimDataNavItemActive = this.checkIfActive([
          'sensorise-sim-data-details',
          'sensorise-sim-manual-upload',
        ]);
        this.isUserManagementActive = this.checkIfActive([
          'user-tab',
          'user-role',
          'role-group',
        ]);
        this.isUserTabActive = this.checkIfActive(['user-tab']);
        if (this.userType === 'Super Administrator') {
          this.isUserRoleActive = this.checkIfActive(['user-role']);
          this.isRoleGroup = this.checkIfActive(['role-group']);
        }
        this.isProfileActive = this.checkIfActive(['profile']);
      });
  }

  checkIfActive(requestedRoutes: string[]): boolean {
    // Get the current route path
    const currentRoute = this.activatedRoute.firstChild?.snapshot.url
      .map((segment) => segment.path)
      .join('/');
    return requestedRoutes.some((route) => currentRoute?.includes(route));
  }

  logout() {
    sessionStorage.removeItem('token');
    sessionStorage.setItem('token', '');
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace('/login');
  }

  toggleDropdown(menu: string) {
    this.activeDropdown = this.activeDropdown === menu ? null : menu;
    if (!menu) {
      this.isMenuOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Check if the clicked element is inside the dropdown or menu
    if (!targetElement.closest('.nav-item')) {
      this.activeDropdown = null;
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleSubMenu(subMenu: string) {
    this.activeSubMenu = this.activeSubMenu === subMenu ? '' : subMenu;
  }

  generateRoute(pageName: string): string {
    return MenuRouteMap[pageName] || '';
  }
}
